<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import { AppDeviceEnquire } from '@/utils/mixin';

export default {
  mixins: [AppDeviceEnquire],
  data() {
    return {
      locale: zhCN,
    };
  },
};
</script>

<style lang="less" scoped>

@font-face {
  font-family: TCloudNumber-Bold; //自定义字体名称
  src: url('https://cdn.map.qq.com/notifysdk/dist-sdk/assets/font/TCloudNumber-Bold.ttf'); //注意引入正确位置
}
@font-face {
  font-family: TCloudNumber-Regular; //自定义字体名称
  src: url('https://cdn.map.qq.com/notifysdk/dist-sdk/assets/font/TCloudNumber-Regular.ttf'); //注意引入正确位置
}
@font-face {
  font-family: TencentSansW7; //自定义字体名称
  src: url('https://cdn.map.qq.com/notifysdk/dist-sdk/assets/font/TencentSansW7.ttf'); //注意引入正确位置
}
@font-face {
  font-family: PingFangSC-Regular; //自定义字体名称
  src: url('https://cdn.map.qq.com/notifysdk/dist-sdk/assets/font/PingFang.ttf'); //注意引入正确位置
}
#app {
  height: 100%;
}
/**
   * 定义滚动条高宽及背景
   * 高宽分别对应横竖滚动条的尺寸
   */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #eff1f4;
}
/**
   *定义滚动条轨迹
内阴影+圆角
   */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #eff1f4;
}
/**
 * 定义滑块
 * 内阴影+圆角
 */
::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #1890ff;
}
body .el-table th.gutter{
display: table-cell!important;
}
</style>
